import React, { useState } from 'react';
import { Button, Notification } from '@bitsoflove/pattyn-360/lib/components';

import AuthPageLayout from '~/containers/AuthLayout/Default';

import { STATE_CHECKING, useAuth, validateLogin } from '~/api/AuthProvider';

function RequestPasswordPage() {
  const { state, requestPassword } = useAuth();
  const loading = state === STATE_CHECKING;
  const [result, setResult] = useState();
  const onSubmit = async ({ email }) =>
    setResult(await requestPassword({ email }));

  let message;
  if (result === true) {
    message = (
      <p>
        <Notification variant="positive">
          Request sent, check your email for further instructions.
        </Notification>
      </p>
    );
  }
  if (result === false) {
    message = (
      <p>
        <Notification variant="negative" icon="notifications">
          Request failed, please check your email address below and try again.
        </Notification>
      </p>
    );
  }

  return (
    <AuthPageLayout
      title="Request new password"
      message={message}
      initialValues={{ email: '' }}
      onSubmit={onSubmit}
      validate={async values => {
        return (await validateLogin(values, 'email')).getErrors();
      }}
    >
      {formik => {
        return (
          <>
            <AuthPageLayout.Field
              formik={formik}
              name="email"
              type="email"
              label="Email"
              placeholder="ex. jan@pattyn.be"
            />

            <Button
              className="login-button"
              variant="primary"
              type="submit"
              block
              disabled={loading || !formik.isValid || result}
              loading={loading}
            >
              Send request
            </Button>
          </>
        );
      }}
    </AuthPageLayout>
  );
}

RequestPasswordPage.options = {
  isPublic: true,
  isAuth: true,
};

export default RequestPasswordPage;
